import { KeyValue } from '@angular/common';

export class SubmissionDetailsFieldChange implements KeyValue<string, string> {
  public key!: string;
  public value!: string;
  public hasChanges!: boolean;

  constructor(public k: string, public v: string, hasChanges: boolean = false) {
    this.key = k;
    this.value = v;
    this.hasChanges = hasChanges;
  }
}
